import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import OrderForm from "./components/OrderForm";
import { site } from "@/config/site";

export default function Purchase() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="pt-24 md:pt-28 pb-16">
        {/* ページタイトル */}
        <div className="bg-background-100 border-b border-background-200">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14 text-center">
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-bold text-primary-700 bg-primary-100 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-shopping-bag-line"></i>
              商品のご購入
            </p>
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              商品をご購入いただけます
            </h1>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
              株式会社MEGURIのジビエ商品をご購入いただけます。
              商品をお選びいただき、必要事項をご入力ください。
            </p>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 md:px-6 mt-10">
          <OrderForm />

          {/* お支払いについて */}
          <section className="mt-12">
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-4 flex items-center gap-2">
              <i className="ri-bank-line text-accent-700"></i>
              お支払いについて
            </h2>
            <div className="bg-background-100 rounded-lg border border-background-200 p-6 space-y-4 text-sm md:text-base text-foreground-700">
              <p className="font-bold text-foreground-950">お支払い方法：銀行振込のみ</p>
              <p>ご注文確定後、下記口座へお振込みをお願いいたします。入金確認後、商品を発送いたします。</p>
              <div className="bg-background-50 rounded-md border border-background-200 p-4 space-y-1 text-sm">
                <p><span className="font-bold">銀行名：</span>{site.bankName}</p>
                <p><span className="font-bold">支店名：</span>{site.bankBranch}</p>
                <p><span className="font-bold">口座種別：</span>{site.bankAccountType}</p>
                <p><span className="font-bold">口座番号：</span>{site.bankAccountNumber}</p>
                <p><span className="font-bold">口座名義：</span>{site.bankAccountHolder}</p>
              </div>
            </div>
          </section>

          {/* 発送について */}
          <section className="mt-10">
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-4 flex items-center gap-2">
              <i className="ri-truck-line text-accent-700"></i>
              発送について
            </h2>
            <div className="bg-background-100 rounded-lg border border-background-200 p-6 space-y-3 text-sm md:text-base text-foreground-700">
              <p>入金確認後、商品を発送いたします。</p>
              <p>在庫がある場合は、入金確認後に速やかに発送いたします。</p>
              <p>在庫がない場合は、ご登録いただいた電話番号へご連絡いたします。</p>
            </div>
          </section>

          {/* 送料 */}
          <section className="mt-10">
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-4 flex items-center gap-2">
              <i className="ri-truck-line text-accent-700"></i>
              送料について
            </h2>
            <div className="bg-background-100 rounded-lg border border-background-200 p-6 space-y-3 text-sm md:text-base text-foreground-700">
              <p>送料：80サイズまで全国一律2,000円。</p>
              <p>北海道・沖縄・離島への発送は、上記送料に＋500円。</p>
              <p className="text-xs text-foreground-500">※商品価格とは別に送料がかかります。</p>
            </div>
          </section>

          {/* LINE案内 */}
          <section className="mt-10">
            <div className="bg-secondary-100 rounded-lg border border-secondary-200 p-6 md:p-8 text-center">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                その他の商品も随時配信いたします。<br className="hidden sm:inline" />
                新商品や入荷情報をお知らせしますので、ぜひ公式LINEをご登録ください。
              </p>
              <a
                href={site.lineUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 mt-5 bg-[#06C755] hover:bg-[#05b34d] text-white text-sm font-bold px-8 py-3.5 rounded-md whitespace-nowrap transition-colors"
              >
                <i className="ri-chat-1-line"></i>
                公式LINEに登録する
              </a>
              <p className="mt-2 text-xs text-foreground-500">
                ※LINEは新商品・入荷情報のお知らせやお問い合わせ用です。商品購入はWebサイト内から行えます。
              </p>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}